import { apiGet, apiPut, apiPost } from "../api-client"

export interface UserProfile {
  id: number
  email: string
  first_name: string
  last_name: string
  title: string
  phone: string
  organization: string
  tenant?: {
    id: string
    name: string
    slug: string
  }
  is_tenant_admin?: boolean
}

export interface UpdateProfileRequest {
  first_name?: string
  last_name?: string
  title?: string
  phone?: string
  organization?: string
}

export interface ChangePasswordRequest {
  old_password: string
  new_password: string
}

/**
 * Fetch the current user's profile information
 */
export async function fetchUserProfile(): Promise<UserProfile> {
  const response = await apiGet<UserProfile>("/api/user/profile/")
  return response
}

/**
 * Update the current user's profile information
 */
export async function updateUserProfile(data: UpdateProfileRequest): Promise<UserProfile> {
  const response = await apiPut<UserProfile>("/api/user/profile/", data)
  return response
}

/**
 * Change the current user's password
 */
export async function changePassword(oldPassword: string, newPassword: string): Promise<{ detail: string }> {
  const response = await apiPost<{ detail: string }>("/api/user/change-password/", {
    old_password: oldPassword,
    new_password: newPassword,
  })
  return response
}
